define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext'
], (Handlebars, Select2, appContext) => {

    function formatState (view, state) {
        let html;
        const tpl = state.enabled ? '<span>{0}</span>' : '<span class="muted">{0}</span>';

        if (view.options.withConnection) {
            html = appContext.tr('{0} (connection #{1}) #{2} {3}').format(
                Handlebars.helpers.h_wa_img(state.provider_id), state.connection_id, state.xid, _.escape(state.name)
            );
        } else {
            html = '{0} #{1} {2}'.format(
                Handlebars.helpers.h_wa_img(state.provider_id), state.xid, _.escape(state.name)
            );
        }
        return tpl.format(html);
    }

    return Select2.extend({

        formatSelection (state) {
            return formatState(this, state);
        },

        formatResult (state) {
            return formatState(this, state);
        },

        matcher (term, text, option) {
            const pattern = term.toUpperCase();
            const provider = appContext.waProviders().get(option.provider_id);
            const providerName = provider ? provider.get('name') : null;

            return option.name.toUpperCase().indexOf(pattern) >= 0 ||
                `${option.xid}`.toUpperCase().indexOf(pattern) >= 0 ||
                (providerName ? providerName.toUpperCase().indexOf(pattern) >= 0 : false);
        }

    });

});
